<template>
  <div class="widget-betascore-page">
    <BetaScoreWidget :score="scoreWithData" />
    <BetaScoreWidget :score="null" />
  </div>
</template>

<script>
import BetaScoreWidget from '@/components/widget/betascore/index.vue'

export default {
  name: 'BetaScoreWidgetPage',
  components: { BetaScoreWidget },
  data() {
    return {
      scoreWithData: {
        score: 58,
        title: 'Low Medium',
        tier: 'Emerging Tier',
        bucket: 3,
        riskLevel: 'Medium',
        dataConfidence: 'High',
        date: new Date('2025-08-29T00:00:00Z')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.widget-betascore-page {
  @include stack-space($space-large);
}
</style>
